import { z } from 'zod';

/**
 * Response of POST /zosapi-macros/run — the Macros tab's "Run as-is". The
 * same shape the Script tab's runner returns (success, stdout, stderr,
 * timing) with the harness payload in `result` (see MacroRunResult in
 * zplMacro.ts). On an over-budget result the runner substitutes a size map,
 * so `result` is left open here and the panel checks `result_truncated`.
 */
export const MacroRunResponseSchema = z.object({
  success: z.boolean(),
  result: z.record(z.string(), z.unknown()).optional(),
  stdout: z.string().optional(),
  stderr: z.string().optional(),
  execution_time_ms: z.number().optional(),
  error: z.string().optional(),
  summary: z.string().optional(),
  system_modified: z.boolean().optional(),
  new_version: z.number().optional(),
});
export type MacroRunResponse = z.infer<typeof MacroRunResponseSchema>;
